import { $win, getCurrentDevice, mapOffsetCenter } from './utils';
import { initShave } from './shave-ui';
import initMapsLinks from './mapsLinks';
import dynamicData from './modules/dynamic-data';

export let markers = [];
export let markerClusterer;
export let map;
export let bounds;
export let isMapsApiLoaded = false;

export const extendBounds = (position) => {
	bounds.extend(position);
}

export const resetBounds = (position) => {
	bounds = new google.maps.LatLngBounds();
}

export const fitBounds = () => {
	map.fitBounds(bounds);
}

const styles = [
	{
		"featureType": "administrative",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#444444"
			}
		]
	},
	{
		"featureType": "administrative.locality",
		"elementType": "labels",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "landscape",
		"elementType": "all",
		"stylers": [
			{
				"color": "#f2f2f2"
			},
			{
				"visibility": "simplified"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [
			{
				"visibility": "simplified"
			},
			{
				"saturation": "-65"
			},
			{
				"lightness": "45"
			},
			{
				"gamma": "1.78"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "labels",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [
			{
				"saturation": -100
			},
			{
				"lightness": 45
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "labels",
		"stylers": [
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "simplified"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [
			{
				"saturation": "-33"
			},
			{
				"lightness": "22"
			},
			{
				"gamma": "2.08"
			}
		]
	},
	{
		"featureType": "transit.station.airport",
		"elementType": "geometry",
		"stylers": [
			{
				"gamma": "2.08"
			},
			{
				"hue": "#ffa200"
			}
		]
	},
	{
		"featureType": "transit.station.airport",
		"elementType": "labels",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit.station.rail",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit.station.rail",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "simplified"
			},
			{
				"saturation": "-55"
			},
			{
				"lightness": "-2"
			},
			{
				"gamma": "1.88"
			},
			{
				"hue": "#ffab00"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [
			{
				"color": "#bbd9e5"
			},
			{
				"visibility": "simplified"
			}
		]
	}
];

const setupMap = () => {
	return new Promise((resolve, reject) => {
		bounds = new google.maps.LatLngBounds();
		const $mapContainers = $('.map');

		$mapContainers.each((index, el) => {
			const $mapContainer = $(el);
			const $map = $mapContainer.find('.map__iframe');
			const mapLat = $map.data('lat') || 0;
			const mapLng = $map.data('lng') || 0;
			const zoom = $map.data('zoom') || 17;
			const $infoboxes = $mapContainer.find('.map__infobox');
			const infoboxClass = $infoboxes.eq(0).attr('class');
			const hasClusters = $map.data('cluster') ? $map.data('cluster') : false;
			const isFullMobile = $map.data('full-mobile') ? $map.data('full-mobile') : false;
			const pinWidth = $map.data('pin-width') ? Number($map.data('pin-width')) : 40;
			const pinHeight = $map.data('pin-height') ? Number($map.data('pin-height')) : 50;
			const hasBounds = $map.data('bounds') ? $map.data('bounds') : false;
			const isDouble = $map.hasClass('js-map-double');
			let mapInst;

			let selectedInfoWindow;

			// Map Options
			const mapOptions = {
				styles,
				zoom,
				center: new google.maps.LatLng(mapLat, mapLng),
				disableDefaultUI: true,
				zoomControl: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.LEFT_BOTTOM
				},
			};

			mapInst = new google.maps.Map($map[0], mapOptions);
			console.log('DEBUG - creating new map');

			map = mapInst;

			// Handle Infobox
			$infoboxes.each((index, el) => {
				const $this = $(el);
				const lat = $this.data('lat');
				const lng = $this.data('lng');
				const pin = $this.data('pin');
				const content = $this.html();
				const closeBoxURL = $this.data('close') ? $this.data('close') : '';
				const isLeftAlign = $this.data('align') ? true : false;
				const id = $this.data('id');
				let pixelOffset = new google.maps.Size(-83, -55);

				if ( isLeftAlign ) {
					pixelOffset = new google.maps.Size(-595, -163 - (Number(pinHeight) / 2));
				}

				const pinMarker = {
					url: pin,
					size: new google.maps.Size(pinWidth, pinHeight),
					scaledSize: new google.maps.Size(pinWidth, pinHeight)
				}

				const position = new google.maps.LatLng(lat, lng);

				bounds.extend(position);

				const marker = new google.maps.Marker({
					position,
					map,
					icon: pinMarker,
					id
				});

				const infowindow = new InfoBox({
					content,
					pixelOffset,
					boxClass: infoboxClass,
					closeBoxMargin: '13px 16px 0px 0px',
					closeBoxURL,
					alignBottom: !isLeftAlign,
					alignLeft: isLeftAlign
				});

				markers.push(marker);

				google.maps.event.addListener(marker, 'click', function() {
					if ( isFullMobile && getCurrentDevice() == 'mobile' ) {
						$(`.map__infobox[data-id="${marker.id}"]`).addClass('active');

						if ( getCurrentDevice() == 'mobile' ) {
							$('body').addClass('modal-open');
						}
					} else {
						if (selectedInfoWindow != null && selectedInfoWindow.getMap() != null ) {
							selectedInfoWindow.close();
						} else if (selectedInfoWindow == infowindow) {
							selectedInfoWindow = null;
						}

						if ( isLeftAlign ) {
							mapOffsetCenter(map, position, 150, 0);
						}

						selectedInfoWindow = infowindow;


						if ( isDouble ) {
							selectedInfoWindow.open(mapInst, this);
						} else {
							selectedInfoWindow.open(map, this);
						}
					}

					setTimeout(() => {
						initShave('.js-shave');
						dynamicData();
						initMapsLinks();
					}, 60);
				});

				google.maps.event.addListener(map, 'click', function() {
					infowindow.close();
				});

				$this.find('.js-close-infobox').on('click', function() {
					$this.removeClass('active');
					$('body').removeClass('modal-open');
				});
			});

			if ( hasBounds ) {
				map.fitBounds(bounds);
			}

			if ( hasClusters ) {
				const clusterImage = $map.data('cluster-image');
				markerClusterer = new MarkerClusterer(map, markers, {
					styles: [
						{
							url: clusterImage,
							width: pinWidth,
							height: pinHeight,
							textColor: '#fff',
							backgroundSize: '100% 100%'
						}
					],
					cssClass: 'cluster-image123',
					gridSize: 22,
					zoomOnClick: true
				});
			}

			$('.js-move-info').each(function() {
				const $this = $(this);
				const $target = $($this.data('target'));
				
				if ( getCurrentDevice() == 'mobile' ) {
					$target.append($this);
				}
			});
		});
		resolve(map)
	});
};

const initMap = () => {
	return new Promise((resolve, reject) => {
		if (isMapsApiLoaded) {
			setupMap();
		} else {
			loadScripts(resolve);			
		}
	});
}

function loadScripts(resolve) {
	return $.getScript(window.googleMapURL, function() {
		return $.getScript(window.googleMapMarkerClustererURL, function() {
			return $.getScript(window.googleMapInfoboxURL, function() {
				isMapsApiLoaded = true;
				return setupMap().then(() => {
					resolve();

					window.dispatchEvent(new Event('mapLoaded'));
				})
			});
		});
	});
}

export default function mapsUI() {
	const $mapContainers = $('.map');

	if ($mapContainers.length) {
		if ( !$mapContainers.first().hasClass('js-load-on-click') ) {
			initMap();
		}
	}

	$('.load-map-api').on('click', function() {
		if (!isMapsApiLoaded) {
			new Promise((resolve, reject) => {
				loadScripts(resolve);
			});
		}
	})
}
